import styled from 'styled-components'

export const MessageBoxStyleAlert = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin-top: 10px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fonts.size.big};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  background-color: ${({ theme }) => theme.colors.alert};
  color: ${({ theme }) => theme.colors.black};
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    background-color: ${({ theme }) => theme.colors.darkAlert};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    img {
      width: 24px;
    }
  }
  p {
    margin: 0;
    width: 100%;
    text-align: center;
  }
  @media screen and (max-width: 720px) {
    font-size: ${({ theme }) => theme.fonts.size.small};
  }

  @media screen and (max-width: 480px) {
    font-size: ${({ theme }) => theme.fonts.size.superSmall};
  }
`

export const MessageBoxStyleError = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin-top: 10px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fonts.size.big};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.trueWhite};
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    background-color: ${({ theme }) => theme.colors.darkError};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    img {
      width: 24px;
    }
  }
  p {
    margin: 0;
    width: 100%;
    text-align: center;
  }

  @media screen and (max-width: 720px) {
    font-size: ${({ theme }) => theme.fonts.size.small};
  }

  @media screen and (max-width: 480px) {
    font-size: ${({ theme }) => theme.fonts.size.superSmall};
  }
`

export const MessageBoxStyleSuccess = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin-top: 10px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.fonts.size.big};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  background-color: ${({ theme }) => theme.colors.success};
  color: ${({ theme }) => theme.colors.black};
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    background-color: ${({ theme }) => theme.colors.darkSuccess};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    img {
      width: 24px;
    }
  }
  p {
    margin: 0;
    width: 100%;
    text-align: center;
  }

  @media screen and (max-width: 720px) {
    font-size: ${({ theme }) => theme.fonts.size.small};
  }

  @media screen and (max-width: 480px) {
    font-size: ${({ theme }) => theme.fonts.size.superSmall};
  }
`
